import { z } from 'zod';
import { join } from 'node:path';

export const VELO_DEPENDENCIES_CONFIG_FILENAME = 'velo.dependencies.json';
export const VELO_DEPENDENCIES_CONFIG_PATH = join(
  'src',
  VELO_DEPENDENCIES_CONFIG_FILENAME
);

export const veloConfigSchema = z.object({
  siteId: z.string().uuid(),
  uiVersion: z.string(),
});
export type VeloConfig = z.infer<typeof veloConfigSchema>;

export const veloDependenciesConfigSchema = z.object({
  dependencies: z.record(z.string()),
});
export type VeloDependenciesConfig = z.infer<
  typeof veloDependenciesConfigSchema
>;

export function getVeloDependenciesConfigPath(projectFolder: string) {
  return join(projectFolder, VELO_DEPENDENCIES_CONFIG_PATH);
}
